var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-activity"},[_c('h1',{staticClass:"c-headline"},[_vm._v("ACTIVITY")]),_c('ActivityContainer',{attrs:{"comments":_vm.comments}}),_c('CustomInfiniteLoader',{attrs:{"infiniteHandler":_vm.infiniteHandler,"margin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }